import { generateClient } from "aws-amplify/api";
import { batchDeleteImages } from "../graphql/mutations";
import _removeImage from "./_removeImage";
import { recordSentry } from "utils/recordSentry";
import { Image } from "db/definitions";

/**
 * Given image docs to delete, removes the images from s3 by their key and removes the image documents
 * @author Eric Webb <ewebb@factorearth.com>
 * @param {Object[]} initialImageDocs The image documents we want to delete
 * @returns The status of the deleted images, or an error
 */
async function batchRemoveImageDocs(initialImageDocs: Image[]): Promise<boolean> {
	if (initialImageDocs.length > 0) {
		try {
			const imageDocsToDelete = [];
			const deletedS3ImagePromises = [];
			for (let i = 0; i < initialImageDocs.length; i++) {
				const imageDoc = initialImageDocs[i];
				if (imageDoc.key && typeof imageDoc.key === "string" && imageDoc.key !== "") {
					deletedS3ImagePromises.push(_removeImage(imageDoc.key, true, "UP"));
					imageDocsToDelete.push({ id: imageDoc.id });
				}
			}
			if (imageDocsToDelete.length > 0) {
				// Batch delete here. Needed the length check because if they're deleting an empty row, no images to delete, batch resolver whines about empty array
				const client = generateClient({ authMode: "userPool" });
				await Promise.all([
					client.graphql({
						query: batchDeleteImages,
						variables: { images: imageDocsToDelete },
						authMode: "userPool",
					}),
					await Promise.all(deletedS3ImagePromises),
				]);
				return true;
			}
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchRemoveImageDocs;
